var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyst3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 334,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 193,
    width: 338,
    height: 334
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-471 -193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M798.018 363.46C839.223 463.372 755.314 526.408 654.139 526.408 552.964 526.408 471 453.455 471 363.46 471 273.464 552.572 193 653.72 193 754.868 193 791.52 235.097 798.018 363.46",
    fill: "#EBF2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.453 435.661 663.046 421.254 655.203 429.097 677.453 451.348 716.392 412.409 708.549 404.566 677.453 435.661Z",
    fill: "#103CA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 328.969C616.264 332.041 613.773 334.532 610.701 334.532 607.629 334.532 605.138 332.041 605.138 328.969 605.138 325.897 607.629 323.406 610.701 323.406 613.773 323.406 616.264 325.897 616.264 328.969Z",
    fill: "#103CA3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 373.471C616.264 376.543 613.773 379.034 610.701 379.034 607.629 379.034 605.138 376.543 605.138 373.471 605.138 370.399 607.629 367.908 610.701 367.908 613.773 367.908 616.264 370.399 616.264 373.471Z",
    fill: "#103CA3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 417.972C616.264 421.044 613.773 423.535 610.701 423.535 607.629 423.535 605.138 421.044 605.138 417.972 605.138 414.9 607.629 412.409 610.701 412.409 613.773 412.409 616.264 414.9 616.264 417.972Z",
    fill: "#103CA3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.016 301.156 594.014 301.156C587.91 301.156 582.888 306.178 582.888 312.282L582.888 434.66C582.888 440.763 587.91 445.785 594.014 445.785L638.515 445.785 638.515 434.66 594.014 434.66 594.014 401.284 694.141 401.284 694.141 312.282C694.141 306.178 689.119 301.156 683.016 301.156ZM683.016 390.159 594.014 390.159 594.014 356.783 683.016 356.783 683.016 390.159ZM683.016 345.657 594.014 345.657 594.014 312.282 683.016 312.282 683.016 345.657Z",
    fill: "#103CA3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyst3);
export default __webpack_public_path__ + "static/media/analyst3.b941c4df49fe0262e5d47d66b7841d96.svg";
export { ForwardRef as ReactComponent };